import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../utils/axiosConfig";
import { confirmToast, showToast } from "../utils/toast";
import ReminderModal from "./ReminderModal";

const DealNavigation = ({ dealId, openBuyer, openShipper, openFixation, openFollowup }) => {

  const navigate = useNavigate();
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [showReminder, setShowReminder] = useState(false);
  const location = useLocation();
  const isActive = (segment) => location.pathname.includes(segment);
  const navClass = (segment) => `btn btn-sm ${isActive(segment) ? "btn-primary" : "btn-outline-primary"}`;

  const openShipmentSchedule = async () => {
    try {
      const response = await axios.get(`/newdeal/${dealId}`);
      const paymentMode = response.data?.payment?.PaymentMode;
      const paidAdvance = Number(response.data?.advanceSummary?.paidAdvance || 0);

      if (paymentMode === "CUSTOM" && !(paidAdvance > 0)) {
        alert("Please save at least one advance payment before proceeding to shipment.");
        return;
      }

      navigate(`/transaction/shipment-schedule/${dealId}`);
    } catch (err) {
      alert(err.response?.data?.message || "Unable to verify advance payment");
    }
  };

  const changeStatus = async (status, label) => {
    if (!await confirmToast(`${label} this deal?`)) return;
    setUpdatingStatus(true);
    try {
      const response = await axios.patch(`/newdeal/${dealId}/status`, { status });
      showToast(response.data?.message || `Deal marked as ${label}`);
      navigate("/transaction/new-deal/list");
    } catch (err) {
      showToast(err.response?.data?.message || `Unable to mark deal as ${label}`);
    } finally {
      setUpdatingStatus(false);
    }
  };

  return (
    <>
    <div className="deal-navigation d-flex justify-content-between mb-3">

      {/* LEFT SIDE BUTTONS */}
      <div className="btn-group">

        <button
          className={navClass("/new-deal/")}
          aria-current={isActive("/new-deal/") ? "page" : undefined}
          onClick={() => navigate(`/transaction/new-deal/edit/${dealId}`)}
        >
          Deal Info
        </button>

        <button
          className={navClass("/purchase-contract/")}
          aria-current={isActive("/purchase-contract/") ? "page" : undefined}
          onClick={() => navigate(`/transaction/purchase-contract/${dealId}`)}
        >
          Purchase Order
        </button>

        <button
          className={navClass("/sales-contract/")}
          aria-current={isActive("/sales-contract/") ? "page" : undefined}
          onClick={() => navigate(`/transaction/sales-contract/${dealId}`)}
        >
          Sales Contract
        </button>

        <button
          className={navClass("/advance-payment/")}
          aria-current={isActive("/advance-payment/") ? "page" : undefined}
          onClick={() => navigate(`/transaction/advance-payment/${dealId}`)}
        >
          Advance Payment
        </button>

        <button
          className={navClass("/shipment-schedule/")}
          aria-current={isActive("/shipment-schedule/") ? "page" : undefined}
          onClick={openShipmentSchedule}
        >
          Shipment Schedule
        </button>

        <button
          className={navClass("/container-release/")}
          aria-current={isActive("/container-release/") ? "page" : undefined}
          onClick={() => navigate(`/transaction/container-release/${dealId}`)}
        >
          Container Release
        </button>

        <button
          className={navClass("/attachment/")}
          aria-current={isActive("/attachment/") ? "page" : undefined}
          onClick={() => navigate(`/transaction/attachment/${dealId}`)}
        >
          Attachment
        </button>

      </div>


      {/* RIGHT SIDE BUTTONS */}
      <div className="btn-group">

        <button
          className="btn btn-secondary btn-sm"
          onClick={openBuyer}
        >
          Buyer Detail
        </button>

        <button
          className="btn btn-secondary btn-sm"
          onClick={openShipper}
        >
          Shipper Detail
        </button>

        {openFixation && (
          <button
            className="btn btn-success btn-sm"
            onClick={openFixation}
          >
            Fixation
          </button>
        )}
        <button type="button" className="btn btn-primary btn-sm" disabled={!dealId}
          onClick={() => setShowReminder(true)}>Reminder</button>

        <button type="button" className="btn btn-danger btn-sm" disabled={updatingStatus}
          onClick={() => changeStatus(2, "Cancel")}>
          Cancel
        </button>

        <button type="button" className="btn btn-info btn-sm" disabled={updatingStatus}
          onClick={() => navigate(`/transaction/claim/${dealId}`)}>
          Claim
        </button>

        <button
          className="btn btn-warning btn-sm"
          onClick={openFollowup}
        >
          Followup
        </button>

        <button
          className="btn btn-dark btn-sm"
          onClick={() => window.open(`/api/report/deal/${dealId}`, "_blank")}
        >
          Report
        </button>

      </div>

    </div>
    {showReminder && <ReminderModal dealId={dealId} onClose={() => setShowReminder(false)} />}
    </>
  );
};

export default DealNavigation;
